/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S3_Item1Inputs */

const tr_hakkimizda_s3_item1 = /** @type {(inputs: Hakkimizda_S3_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Workers (edge compute, küresel düşük gecikme)`)
};

const en_hakkimizda_s3_item1 = /** @type {(inputs: Hakkimizda_S3_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Workers (edge compute, low global latency)`)
};

const de_hakkimizda_s3_item1 = /** @type {(inputs: Hakkimizda_S3_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Workers (Edge Compute, weltweit niedrige Latenz)`)
};

const ru_hakkimizda_s3_item1 = /** @type {(inputs: Hakkimizda_S3_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Workers (edge compute, низкая задержка по всему миру)`)
};

/**
* | output |
* | --- |
* | "Cloudflare Workers (edge compute, low global latency)" |
*
* @param {Hakkimizda_S3_Item1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s3_item1 = /** @type {((inputs?: Hakkimizda_S3_Item1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S3_Item1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s3_item1(inputs)
	if (locale === "de") return de_hakkimizda_s3_item1(inputs)
	if (locale === "ru") return ru_hakkimizda_s3_item1(inputs)
	return tr_hakkimizda_s3_item1(inputs)
});